import { makeStyles } from '@material-ui/styles';

import { AddFill, MainButton, Text } from '@bizzabo/design-system';

import { useMeetings, View } from '../../MeetingsTool/MeetingsToolContext';
import useTypeTracking from '../../../../analytics';

const Header: React.FC = () => {
    const classes = useStyles();
    const { setView } = useMeetings();
    const { trackClickEvent } = useTypeTracking();

    const newMeetingHandle = () => {
        setView(View.ZeroState);
        trackClickEvent({
            subCategory: 'NEW_MEETING_CLICKED',
            description: {
                flow: 'CREATE_MEETING',
                meeting_participant_role: 'HOST',
            },
        });
    };

    return (
        <div className={classes.header}>
            <div className={classes.topHeader}>
                <Text variant="t40">My Meetings</Text>
                <MainButton
                    className={classes.newMeetingBtn}
                    variant="fillPrimary"
                    size="small"
                    before={<AddFill />}
                    onClick={newMeetingHandle}
                >
                    New
                </MainButton>
            </div>
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        header: {
            padding: '40px 30px 10px',
            color: theme.customization.background.C30,
        },
        topHeader: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        newMeetingBtn: {
            height: 28,
        },
    }),
    { classNamePrefix: 'meetings-header' }
);

export default Header;
